import BaseService from '@/ecm/common/BaseService.js';

class LicenceService {
  baseUrl = 'licence';

  getCurrent = () => BaseService.get({ url: `${this.baseUrl}/get-current` });
  request = (licenceRequest) => BaseService.post({ url: `${this.baseUrl}/request`, data: licenceRequest });
}

export default new LicenceService();
